import * as X from "@/ui";

import ZapptaxIconBlack from "@/assets/shared-zapptax-icon-black.svg";
import TravelerImage from "@/assets/bucket/retailer-home-traveler.png";
import ReactMarkdown from "react-markdown";
import { SatisfactionCard, TravelerCard } from "@/providers/strapi/content/types/components/retailer.component";


// const data = {
//   travelerTitle: {
//     // en: <>Are you <strong>a traveler?</strong></>,
//     // fr: <>Vous êtes <strong>un voyageur{X.Nbsp}?</strong></>,
//     ko: '현재 여행 중이신가요?',
//   },

//   travelerText: {
//     // en: <>Shop smart. Save more.<br />With Zapptax, tax-free shopping is effortless. Making your shopping therapy all pleasure, no hassle.</>,
//     // fr: <>Voyagez, shoppez, économisez. Notre application rend la détaxe facile et sans stress, pour que votre shopping ne rime qu’avec plaisir.</>,
//     ko: '스마트하게 쇼핑하고 더 많이 절약해 보세요.Zapptax와 함께라면 면세 쇼핑이 더욱 간편해집니다. 쇼핑을 더욱 더 즐겁고 편하게 즐겨보세요.',
//   },

//   travelerMoreInfosCta: {
//     // en: "Find out more",
//     // fr: "En savoir plus ?",
//     ko: "자세히 알아보기",
//   },

//   travelerDownloadAppCta: {
//     // en: "Download the app",
//     // fr: "Téléchargez l'app",
//     ko: "앱 다운로드",
//   },
// };


export function TravelerSection({ onDownloadApp, travelerCard, satisfactionCard, ...pageProps }: X.PageProps<{
  onDownloadApp: () => void;
  travelerCard: TravelerCard;
  satisfactionCard: SatisfactionCard
}>) {
  return (
    <>
      <Mobile {...pageProps} travelerCard={travelerCard} />
      <Desktop {...pageProps} onDownloadApp={onDownloadApp} satisfactionCard={satisfactionCard} travelerCard={travelerCard} />
    </>
  );
}


function Mobile(props: X.PageProps<{ travelerCard: TravelerCard }>) {
  // const tr = X.useTranslator<"ko">(props);
  const downloadUrl = X.useDownloadUrl(props.locale);

  // const travelerSection = useRetailerHomePage('travelerCard')
  const travelerCard = props.travelerCard;
  return (
    <section className={X.clsx(X.mobileOnly(), "relative xl:my-10 mx-mobile-margin flex flex-col gap-5")}>
      {/* <h3 className="text-[30px] [&_strong]:font-medium leading-tight">
        {tr(data.travelerTitle)}
      </h3> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <h3  {...props} className="text-[30px] [&_strong]:font-medium leading-tight" />
      }}>
        {/* {tr({
          fr: travelerCard.title,
          en: travelerCard.title,
          ko: data.travelerTitle.ko,
          zh: ""
        })} */}
        {travelerCard.title}
      </ReactMarkdown>

      <div className="flex flex-row gap-2 items-stretch mb-4">
        {/* <p className="text-[16px] w-[60%] leading-tight">

          {travelerCard.content}
          {tr({
            fr: travelerCard.content,
            en: travelerCard.content,
            ko: data.travelerText.ko,
            zh: ""
          })}
          {travelerCard.content}
        </p> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <p {...props} className="text-[16px] w-[60%] leading-tight" />
        }}>
          {travelerCard.content}
        </ReactMarkdown>
        <div className="w-[180px]">
          {/* <X.Image
            src={TravelerImage}
            alt="Traveler"
            className="h-auto"
          /> */}
          <X.Image
            src={travelerCard.picture.url}
            width={travelerCard.picture.width}
            height={travelerCard.picture.height}
            unoptimized
            alt="Traveler"
            className="h-auto rounded-2xl"
          />
        </div>
      </div>

      <div className="flex flex-row gap-4 justify-start">
        <X.Button primary exitHref={downloadUrl}
          // label={tr(data.travelerDownloadAppCta)}
          // label={tr({
          //   fr: travelerCard.downloadCta,
          //   en: travelerCard.downloadCta,
          //   ko: data.travelerDownloadAppCta.ko,
          //   zh: ""
          // })}
          label={travelerCard.downloadCta}
        />
        <X.Button tertiary href="/"
          // label={tr(data.travelerMoreInfosCta)}
          label={travelerCard.knowMoreCTA}
        // label={tr({
        //   fr: travelerCard.knowMoreCTA,
        //   en: travelerCard.knowMoreCTA,
        //   ko: data.travelerMoreInfosCta.ko,
        //   zh: ""
        // })}
        />
      </div>
    </section>
  );
}


function Desktop(props: X.PageProps<{
  onDownloadApp: () => void;
  travelerCard: TravelerCard,
  satisfactionCard: SatisfactionCard
}>) {
  // const tr = X.useTranslator<"ko">(props);
  const travelerSection = props.travelerCard; //useRetailerHomePage('travelerCard')
  const satisfactionCard = props.satisfactionCard;//useRetailerHomePage('satisfactionCard')
  return (
    <section className={X.clsx(X.desktopOnly("flex"), "relative my-20 max-w-content mx-auto flex-row items-stretch gap-8")}>
      <div className={X.clsx("bg-yellow rounded-2xl relative p-8 pr-20")}>
        {/* <p className="font-medium text-[90px]">
          {satisfactionCard.label}
          {tr({
            en: satisfactionCard.label,//"satisfied travelers",
            fr: satisfactionCard.label,//"voyageurs satisfaits",
            ko: "150.000",
            zh: ""
          })}
        </p> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <p {...props} className="font-medium text-[90px]" />
        }}>
          {satisfactionCard.label}
        </ReactMarkdown>
        {/* <p className="text-[24px]">
          {tr({
            en: satisfactionCard.content,//"satisfied travelers",
            fr: satisfactionCard.content,//"voyageurs satisfaits",
            ko: "행복한 여행자들",
            zh: ""
          })}
          {satisfactionCard.content}
        </p> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <p {...props} className="text-[24px]" />
        }}>
          {satisfactionCard.content}
        </ReactMarkdown>
        <X.Image
          src={ZapptaxIconBlack}
          alt="Zapptax"
          className="w-[30px] h-auto top-5 right-5 absolute"
        />
      </div>

      <div className="flex flex-row flex-1 gap-[28px] pr-4">
        {/* <X.Image
          src={TravelerImage}
          alt="Traveler"
          className="w-auto h-[236px]"
        /> */}
        <X.Image
          src={props.travelerCard.picture.url}
          width={props.travelerCard.picture.width}
          height={props.travelerCard.picture.height}
          unoptimized
          alt="Traveler"
          className="w-auto h-[236px] rounded-2xl"
        />
        <div className="flex flex-col gap-1 justify-between">
          {/* <h3 className="text-[36px] [&_strong]:font-medium leading-[38px] pt-1">
            {tr(data.travelerTitle)}
          </h3> */}
          <ReactMarkdown components={{
            p: ({ ...props }) => <h3  {...props} className="text-[36px] [&_strong]:font-medium leading-[38px] pt-1" />
          }}>
            {/* {tr({
              fr: travelerSection.title,
              en: travelerSection.title,
              ko: data.travelerTitle.ko,
              zh: ""
            })} */}
            {travelerSection.title}
          </ReactMarkdown>
          {/* <p className="text-[20px] leading-tight pb-2">

            {travelerSection.content}

          </p> */}
          <ReactMarkdown components={{
            p: ({ ...props }) => <p {...props} className="text-[20px] leading-tight pb-2" />
          }}>
            {travelerSection.content}
          </ReactMarkdown>
          <div className="flex flex-row gap-4">
            <X.Button tertiary lg href="/"

              // label={tr(data.travelerMoreInfosCta)}
              // label={tr({
              //   fr: travelerSection.knowMoreCTA,
              //   en: travelerSection.knowMoreCTA,
              //   ko: data.travelerMoreInfosCta.ko,
              //   zh: ""
              // })}
              label={travelerSection.knowMoreCTA}

            />
            <X.Button primary lg onClick={props.onDownloadApp}
              // label={tr(data.travelerDownloadAppCta)}
              // label={tr({
              //   fr: travelerSection.downloadCta,
              //   en: travelerSection.downloadCta,
              //   ko: data.travelerDownloadAppCta.ko,
              //   zh: ""
              // })}
              label={travelerSection.downloadCta}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
